import CustomText from "../atomic/CustomText";
import DocumentManagement from "../atomic/DocumentManagement";
import DetailRenderer from "../global/forms/DetailRenderer";
import ShipmentInformationReview from "../global/forms/OnlineOrderReviews/ShipmentInformationReview";
import AdditionalInformation from "./AdditionalInformation";
import BillingInformation from "./BillingInformation";
import ClinicalInformation from "./ClinicalInformation";
import ClinicianInformation from "./ClinicianInformation";
import GuarantorInfo from "./GuarantorInfo";
import LaboratoryInfo from "./LaboratoryInfo";
import PatientInformation from "./PatientInformation";


interface ReviewSectionProps {
  isChecked: boolean;
  index: number;
  order: any;
  handleCheckboxChange: (id: string) => void;
}

const ReviewSection: React.FC<ReviewSectionProps> = ({
  isChecked,
  index,
  order,
  handleCheckboxChange,
}) => {
  return (
    <div key={index}>
      <label
        htmlFor="additionalClinician"
        className="checkboxContainer block"
        onClick={() => handleCheckboxChange(order?.supportingSection?.id)}
      >
        <input
          type="checkbox"
          name="additionalClinician"
          checked={isChecked}
          className="mr-2"
        />
        <span className="checkmark" />
        <span>{`${index + 1}.${order?.header?.patientName} - ${order?.header?.test
          }`}</span>
      </label>
      <div id={`${order?.supportingSection?.id}-patient-info`}>
        <PatientInformation order={order} />
      </div>
      <div id={`${order?.supportingSection?.id}-billing-info-medicare`}>
        <BillingInformation order={order} />
      </div>
      {order?.testType?.test === 9 && <div id={`${order?.supportingSection?.id}-guarantor-info`}>
        <GuarantorInfo order={order} />
      </div>}
      <ClinicianInformation order={order} />
      {order?.testType?.test !== 1 && (
        <div id={`${order?.supportingSection?.id}-clinical-info`}>
          <ClinicalInformation order={order} />
        </div>
      )}
      {order?.additionalInfo?.length > 0 && (
        <div id={`${order?.supportingSection?.id}-additional-info`}>
          <AdditionalInformation order={order} />
        </div>
      )}
      
        <div id={`${order?.supportingSection?.id}-shipment-info`}>
        <CustomText
      text={"Shipment Information"}
      fontWeight="font-medium"
      className="reviewCardHeading my-5"
    />
    
      <ShipmentInformationReview values={order} />
      </div>
      <div id={`${order?.supportingSection?.id}-laboratory-info`}>
        <LaboratoryInfo order={order} />
      </div>

      <div
        id={`${order?.supportingSection?.id}-supporting-doc`}
        className="mb-3"
      >
        <DocumentManagement
          uploadedDocs={order?.supportingDocs ?? order?.supportingDocuments}
          values={order}
          approval={true}
        />
      </div>
    </div>
  );
};

export default ReviewSection;
